import React from 'react';
import SelectCourse from './SelectCourse';

const OldAll = props => (
  <SelectCourse {...props} design="legacy" forcedPlatform="all" />
);

export default OldAll;
